import * as React from 'react'
import styled from 'styled-components'

// https://css-tricks.com/snippets/css/css-triangle/

export interface ArrowProps {
  point: 'up' | 'down' | 'right' | 'left'
  color: string
  size: string
}

const ArrowBase = styled.div<ArrowProps>`
  width: 0;
  height: 0;
`

const Up = styled(ArrowBase)`
  border-left: ${({ size }) => size} solid transparent;
  border-right: ${({ size }) => size} solid transparent;

  border-bottom: ${({ size }) => size} solid ${({ color }) => color};
`

const Down = styled(ArrowBase)`
  border-left: ${({ size }) => size} solid transparent;
  border-right: ${({ size }) => size} solid transparent;

  border-top: ${({ size }) => size} solid ${({ color }) => color};
`

const Right = styled(ArrowBase)`
  border-top: ${({ size }) => size} solid transparent;
  border-bottom: ${({ size }) => size} solid transparent;

  border-left: ${({ size }) => size} solid ${({ color }) => color};
`

const Left = styled(ArrowBase)`
  border-top: ${({ size }) => size} solid transparent;
  border-bottom: ${({ size }) => size} solid transparent;

  border-right: ${({ size }) => size} solid ${({ color }) => color};
`

const pointMap = { up: Up, down: Down, right: Right, left: Left }

const Arrow: React.FunctionComponent<ArrowProps> = props => {
  const Component = pointMap[props.point]
  return <Component {...props} />
}

export default Arrow



// WEBPACK FOOTER //
// ./src/components/Tooltip/Arrow.tsx